import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Card, CustomNumberInput } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import ModalUpload from './ModalUpload';


const MdrInsert = (props) => {
    const [model, setModel] = useState(props.location?.state?.update && props.mdr ? props.mdr : {});
    const [openModal, setOpenModal] = useState(false);
    const update = props.location?.state?.update;

    useEffect(() => {
        if (props.location?.state?.update && props.mdr) {
            setModel({ ...props.mdr });
        }
        // eslint-disable-next-line
    }, [props.location?.state?.update, props.mdr]);


    const onChange = (event) => {
        onValueChange(event, model, setModel);

    };

    const onChangeVolume = (event) => {
        model.volume = parseFloat(event.target.value.replace(",", "."));
        setModel({ ...model });
    };

    const onChangeWeight = (event) => {
        model.weight = parseFloat(event.target.value.replace(",", "."));
        if (model.height && model.width && model.length) {
            model.volume = (model.height * model.width * model.length) / 1000;
        }
        setModel({ ...model });
    };

    const onChangeHeigth = (event) => {
        model.height = parseFloat(event.target.value.replace(",", "."));
        if (model.height && model.width && model.length) {
            model.volume = (model.height * model.width * model.length) / 1000;
        }
        setModel({ ...model });
    };

    const onChangeWidth = (event) => {
        model.width = parseFloat(event.target.value.replace(",", "."));
        if (model.height && model.width && model.length) {
            model.volume = (model.height * model.width * model.length) / 1000;
        }
        setModel({ ...model });
    };

    const onChangeLength = (event) => {
        model.length = parseFloat(event.target.value.replace(",", "."));
        if (model.height && model.width && model.length) {
            model.volume = (model.height * model.width * model.length) / 1000;
        }
        setModel({ ...model });
    };

    const add = () => {
        if (!validateInputsRequired()) {
            return;
        }

        if (update) {
            props.updateMdr(model, (data) => {
                if (data.success) {
                    props.getMdr();
                    showMessageToastCustom(translate('info', 'general'), translate('success', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    props.history.go(-1);
                }
            });
        }
        else {
            props.addMdr(model, (success) => {
                if (success) {
                    props.getMdr();
                    showMessageToastCustom(translate('info', 'general'), translate('success', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    props.history.go(-1);
                }
            });
        }
    }

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: update ? 'Editar Embalagem' : 'Adicionar Embalagem' }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding outlined col s4">
                                <Input
                                    id="code"
                                    name='code'
                                    label='Embalagem'
                                    type="text"
                                    maxLength="5"
                                    required
                                    value={model?.code || ''}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="input-field no-padding outlined col s5">
                                <Input
                                    id="description"
                                    name='description'
                                    label='Descrição'
                                    type="text"
                                    maxLength="40"
                                    required
                                    value={model?.description || ''}
                                    onChange={onChange}

                                />
                            </div>
                            <div className="input-field no-padding outlined col s3">
                                <CustomNumberInput
                                    id="height"
                                    name='height'
                                    label='Altura'
                                    maxLength="6"
                                    value={model?.height || ''}
                                    onChange={onChangeHeigth}

                                />
                            </div>
                            <div className="input-field no-padding outlined col s3">
                                <CustomNumberInput
                                    id="width"
                                    name='width'
                                    label='Largura'
                                    maxLength="6"
                                    value={model?.width || ''}
                                    onChange={onChangeWidth}

                                />
                            </div>
                            <div className="input-field no-padding outlined col s4">
                                <CustomNumberInput
                                    id="length"
                                    name='length'
                                    label='Comprimento'
                                    maxLength="6"
                                    value={model?.length || ''}
                                    onChange={onChangeLength}

                                />
                            </div>
                            <div className="input-field no-padding outlined col s3">
                                <CustomNumberInput
                                    id="volume"
                                    name='volume'
                                    label='Volume'
                                    disabled
                                    maxLength="6"
                                    value={model?.volume || ''}
                                    onChange={onChangeVolume}
                                >
                                </CustomNumberInput>
                            </div>
                            <div className="input-field no-padding outlined col s3">
                                <CustomNumberInput
                                    id="weight"
                                    name='weight'
                                    label='Peso'
                                    maxLength="6"
                                    value={model?.weight || ''}
                                    onChange={onChangeWeight}
                                >
                                </CustomNumberInput>
                            </div>
                            {!update &&
                                <div className="row">
                                    <div className="input-field no-padding  col s1">
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => setOpenModal(true)}>
                                            <i className="Small material-icons">cloud_upload</i>
                                        </button>
                                    </div>
                                </div>}

                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button text={translate("general:confirm")} onClick={() => add()} />
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            <ModalUpload
                open={openModal}
                id="ModalUpload"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        mdr: state.containerReducer.mdr
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addMdr: (model, callback) => {
            dispatch(ContainerService.insertMdr(model, callback));
        },
        updateMdr: (model, callback) => {
            dispatch(ContainerService.updateMdr(model, callback));
        },
        getMdr: () => {
            dispatch(ContainerService.getMdrPaged());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MdrInsert));
